import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation } from '@tanstack/react-query';
import { useNotifications } from '@toolpad/core';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router';
import { Card, CardContent, CardHeader } from '@mui/material';

import Api from '@barboxx/api';
import { BusinessSignup } from '@barboxx/models';

import {
    BUSINESS_SIGNUP_SCHEMA,
    BusinessDetailsForm,
} from './BusinessDetailsForm';

interface BusinessDetailsCardProps {
    businessDetails: BusinessSignup;
}

export function BusinessDetailsCard({
    businessDetails,
}: BusinessDetailsCardProps) {
    const { signupId } = useParams();
    const notifications = useNotifications();

    const formContext = useForm<BusinessSignup.UpdateRequest>({
        resolver: yupResolver(BUSINESS_SIGNUP_SCHEMA),
        defaultValues: businessDetails,
    });

    const mutateSignup = useMutation({
        mutationKey: ['businessSignup', signupId],
        mutationFn: (data: BusinessSignup.UpdateRequest) =>
            Api.Businesses.updateSignupById(data),
    });

    const handleSubmit = (values: BusinessSignup.UpdateRequest) =>
        mutateSignup
            .mutateAsync(values)
            .then(() => {
                notifications.show('Successfully signed up!', {
                    severity: 'success',
                });
                formContext.reset(values);
            })
            .catch((error: Error) => {
                notifications.show(error.message, {
                    severity: 'error',
                });
            });

    return (
        <Card>
            <CardHeader
                title="Business Info"
                titleTypographyProps={{
                    variant: 'h5',
                }}
                align="center"
                sx={{ paddingBottom: 0 }}
            />
            <CardContent>
                <BusinessDetailsForm
                    formContext={formContext}
                    onSubmit={handleSubmit}
                />
            </CardContent>
        </Card>
    );
}
